



























import { Component, Vue, Prop } from 'vue-property-decorator';
import FlexButton from '@/components/FlexButton/FlexButton.vue';

@Component({
  components: {
    FlexButton
  }
})
export default class TemplateModal extends Vue {
  @Prop({ required: true }) text!: string;
  @Prop({ required: true }) confirmLabel!: string;
  @Prop({ required: false, default: 'Not now' }) cancelLabel!: string;
  @Prop({ required: false }) bottomText!: string;
  @Prop({ required: false }) hideCancelBtn!: boolean;
  @Prop({ required: false }) hideCloseBtn!: boolean;
  @Prop({ required: false }) loading!: boolean;
  @Prop({ required: false }) showContent!: boolean;

  onClose(event: any) {
    this.$emit('onClose', event);
  }

  onCancel(event: any) {
    this.$emit('onCancel', event);
  }

  onConfirm(event: any) {
    this.$emit('onConfirm', event);
  }
}
